import React, { useState } from "react";
import { useNavigate } from "react-router";
const CDN_URL = "https://d1rfo5pw240a8w.cloudfront.net/";
export default function Thankyou({ helmet = null }) {
  const navigate = useNavigate();
  return (
    <div className="nk-main" style={{ background: "white" }}>
      <div className="nk-wrap nk-wrap-nosidebar">
        <div className="nk-content ">
          <div className="nk-split nk-split-page nk-split-lg">
            <div
              className="nk-split-content nk-block-area nk-block-area-column nk-auth-container w-lg-45"
              style={{ margin: "auto" }}
            >
              <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                <a
                  href="#"
                  className="toggle btn btn-white btn-icon btn-light"
                  data-target="athPromo"
                >
                  <em className="icon ni ni-info"></em>
                </a>
              </div>
              {helmet && helmet}
              <div
                className="nk-block nk-block-middle nk-auth-body"
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  background: "#fff",
                  borderRadius: "8px",
                  padding: "0.5rem",
                  paddingLeft: "0rem",
                }}
              >
                <div
                  className="brand-logo pb-5"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <a href="/demo2/index.html" className="logo-link">
                    <img
                      className="logo-light logo-img logo-img-lg"
                      src={CDN_URL + "auth-ahrvo-logo.png"}
                      alt="logo"
                    />
                    <img
                      className="logo-dark logo-img logo-img-lg"
                      src={CDN_URL + "auth-ahrvo-logo.png"}
                      alt="logo-dark"
                    />
                  </a>
                </div>
                <div className="nk-block-head">
                  <div className="nk-block-head-content">
                    <h5
                      className="nk-block-title"
                      style={{
                        marginTop: "4rem",
                        marginBottom: "1rem",
                        marginLeft: "1rem",
                        marginRight: "1rem",
                        marginLeft: "0rem",
                      }}
                    >
                      Transitioning to Onboarding – Get Your Documents Ready!
                    </h5>
                    <div className="nk-block-des">
                      <p>
                        You're moving to the Onboarding section to complete your
                        KYB process for marketplace access. Have your legal
                        documents ready for a smooth verification. Please finish
                        in one session and review the “Items You Need” list
                        before starting. Let's get you onboarded!
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "3rem",
                  }}
                >
                  <button
                    onClick={() => navigate("/onboarding")}
                    className="btn btn-primary"
                  >
                    Get Started
                  </button>
                </div>
              </div>
              <div
                className="nk-block nk-auth-footer"
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  background: "#fff",
                  borderRadius: "8px",
                }}
              >
                <div className="nk-block-between">
                  <ul className="nav nav-sm">
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        target="_blank"
                        href="https://kycaml.tech/website-terms-conditions/"
                      >
                        Terms and Conditions
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        href="https://kycaml.tech/platform-privacy-notice/"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="mt-3">
                  <p>&copy;2024 AHRVO COMPLY. ALL RIGHTS RESERVED.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
